const labelEnum = Object.freeze({
    HOME: "Home",
    WORK: "Work",
    OTHER: "OTHER",
});
export default labelEnum;
